import { render } from "./CurrentUser.vue?vue&type=template&id=156a8ace&ts=true"
import script from "./CurrentUser.vue?vue&type=script&lang=ts"
export * from "./CurrentUser.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__